import * as React from 'react';
import type { SVGProps } from 'react';
const SvgKhavarmianelogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width={25}
    height={24}
    fill='none'
    {...props}
  >
    <circle cx={12.5} cy={12} r={11.5} fill='url(#khavarmianelogo_svg__a)' stroke='#E0E3EB' />
    <defs>
      <pattern
        id='khavarmianelogo_svg__a'
        width={1}
        height={1}
        patternContentUnits='objectBoundingBox'
      >
        <use xlinkHref='#khavarmianelogo_svg__b' transform='scale(.00385)' />
      </pattern>
      <image
        xlinkHref='/images/icons/khavarmianelogo-f09b1e80.webp'
        id='khavarmianelogo_svg__b'
        width={260}
        height={260}
      />
    </defs>
  </svg>
);
export default SvgKhavarmianelogo;
